import React from 'react';
import { format } from 'date-fns';
import { Paperclip, Ban } from 'lucide-react';

// One conversation row in the Email Inbox triage list.
export default function EmailInboxItem({ message, unread, selected, onSelect }) {
  return (
    <button
      onClick={() => onSelect(message)}
      className={`w-full text-left border px-4 py-3 transition-colors ${
        selected
          ? 'border-primary bg-primary/5'
          : unread
            ? 'border-primary/30 bg-[#111115] hover:border-primary/50'
            : 'border-white/5 bg-[#111115] hover:border-white/15'
      }`}
    >
      <div className="flex items-start justify-between gap-2 mb-1">
        <div className="min-w-0 flex-1">
          <p className={`text-sm truncate ${unread ? 'text-white font-bold' : 'text-white/80 font-medium'}`}>
            {message.customer_name || message.from_address || 'Unknown sender'}
          </p>
          <p className="text-white/30 text-xs truncate">{message.from_address || message.customer_email}</p>
        </div>
        {unread && (
          <span className="bg-primary text-white text-[8px] font-bold tracking-widest px-1.5 py-0.5 shrink-0">
            NEW
          </span>
        )}
        {message.auto_generated && (
          <Ban className="w-3 h-3 text-white/20 shrink-0" aria-label="Auto-generated" />
        )}
      </div>
      <p className={`text-xs truncate mb-1 ${unread ? 'text-white/70' : 'text-white/50'}`}>
        {message.subject || '(no subject)'}
      </p>
      <p className="text-white/40 text-xs line-clamp-2 mb-1">{message.body}</p>
      <div className="flex items-center gap-2">
        <p className="text-white/20 text-[9px]">
          {message.created_date ? format(new Date(message.created_date), 'dd MMM yyyy · HH:mm') : ''}
        </p>
        {(message.attachment_names || []).length > 0 && (
          <span className="inline-flex items-center gap-1 text-white/25 text-[9px]">
            <Paperclip className="w-2.5 h-2.5" />
            {message.attachment_names.length}
          </span>
        )}
      </div>
    </button>
  );
}